import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue';
import Home from './views/docs.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      redirect: () => {
        return '/sdk'; //跳转回首页
      }, //路由重定向
    },
    {
      path: '/sdk',
      name: 'home',
      component: Home,
    },
    {
      path: '/sdk/example',
      name: 'example',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "example" */ './views/example.vue'),
    },
    {
      path: '/sdk/exampleItem',
      name: 'exampleItem',
      component: () =>
        import(/* webpackChunkName: "exampleItem" */ './views/exampleItem.vue'),
    },
    {
      path: '/sdk/exampleItemRead',
      name: 'exampleItemRead',
      component: () =>
        import(
          /* webpackChunkName: "exampleItemRead" */ './views/exampleItemRead.vue'
        ),
    },
    {
      path: '/sdk/docs',
      name: 'docs',
      component: () =>
        import(/* webpackChunkName: "docs" */ './views/docs.vue'),
    },
    {
      path: '/sdk/api',
      name: 'api',
      component: () => import(/* webpackChunkName: "api" */ './views/api.vue'),
    },
    {
      path: '*',
      component: () =>
        import(/* webpackChunkName: "error" */ './views/error.vue'),
    },
  ],
});
